import { USER_STATUS, USER_STATUS_JA, LANGUAGE } from '../../constants';
import type { ValueGetterParams } from 'ag-grid-community';
import type { Language, SelectOption } from '../../types/common';

/**
 * userStatusの値からフィルタ用の文字列を生成する（valueはnull/'0'/'1'/'2'/'3'）。
 * 0: 未連絡 1: 初回連絡済 2: ２回連絡済 3: 削除済とする。
 * 解決できなかった場合はvalueをstringとして返す。
 * @param params [ValueGetterParams]
 * @returns string
 */
const userStatusFilterValueGetter = (params: ValueGetterParams) => {
  const value: string = params.getValue('userStatus');
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const filterValue: string = currentLang ? (currentLang.value === LANGUAGE.JA ? USER_STATUS_JA[value] : USER_STATUS[value]) : value;
  return filterValue;
};

export default userStatusFilterValueGetter;
